import { motion } from "framer-motion";
import { MANIFESTO } from "@/data/catalog";

const STUDIO =
  "https://images.unsplash.com/photo-1541095105396-3ab86a4e1727?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxhbmFsb2clMjByZWNvcmRpbmclMjBzdHVkaW8lMjBtaXhlciUyMGRhcmt8ZW58MHx8fHwxNzg2MzA0NzU0fDA&ixlib=rb-4.1.0&q=85";

export const Manifesto = () => {
  return (
    <section id="manifesto" data-testid="manifesto" className="relative bg-charcoal py-24 md:py-40 px-5 md:px-10 border-t border-white/10">
      <div className="max-w-[1600px] mx-auto grid lg:grid-cols-[1fr_0.9fr] gap-14 lg:gap-24">
        <div>
          <p className="font-mono uppercase tracking-[0.3em] text-xs text-signal mb-8">[ Manifesto ]</p>
          <div className="space-y-12 md:space-y-16">
            {MANIFESTO.map((m, i) => (
              <motion.div
                key={m.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                className="grid grid-cols-[auto_1fr] gap-6 md:gap-10 border-b border-white/10 pb-10"
              >
                <span className="font-display text-4xl md:text-6xl text-stroke leading-none">{m.n}</span>
                <div>
                  <h3 className="font-mono uppercase tracking-[0.2em] text-sm text-white mb-3">{m.label}</h3>
                  <p className="font-body text-base md:text-lg text-white/50 leading-relaxed max-w-xl">{m.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 1.05 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="relative"
        >
          <div className="sticky top-28 overflow-hidden border border-white/10 group">
            <img src={STUDIO} alt="Smoke Shop Records studio" className="w-full h-[420px] lg:h-[640px] object-cover grayscale group-hover:grayscale-0 transition-all duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-void/80 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <p className="font-mono uppercase tracking-[0.2em] text-[11px] text-signal mb-2">The Shop / HQ</p>
              <p className="font-display uppercase text-3xl md:text-4xl leading-none text-white">Where the smoke settles</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
